// extracted by css-extract-rspack-plugin
export default {"skeletonContainer":"TemplateList-module__skeletonContainer__tymSU","templateHeader":"TemplateList-module__templateHeader__v1Qp_"};